export default __webpack_public_path__ + "5cc9b1d3f0cf12e74185f117dbc6fba4.png";